import React, { useState, useEffect } from 'react';
import './Footer.css';

const navLinks = [
  { id: 'hero',      label: 'Home' },
  { id: 'features',  label: 'Features' },
  { id: 'detect',    label: 'Detect Disease' },
  { id: 'diseases',  label: 'Disease Library' },
  { id: 'blog',      label: 'Knowledge Base' },
];
const resourceLinks = [
  { id: 'about',    label: 'About Us' },
  { id: 'feedback', label: 'Reviews' },
  { id: 'contact',  label: 'Contact' },
];

export default function Footer({ onAdminClick }) {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const fn = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <footer className="footer-cg">
        <div className="container">
          <div className="row g-5">

            {/* Brand */}
            <div className="col-lg-4">
              <div className="footer-brand">Crop<span>Guard</span> AI</div>
              <div className="footer-desc">
                AI-powered crop disease detection for tomato and maize farmers across South Asia.
                Built as a final-year research project at The Islamia University of Bahawalpur.
              </div>
              <div className="mt-4">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Facebook"><i className="bi bi-facebook"></i></a>
                <a href="https://twitter.com"  target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Twitter X"><i className="bi bi-twitter-x"></i></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
                <a href="https://github.com"   target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="GitHub"><i className="bi bi-github"></i></a>
              </div>
            </div>

            {/* Navigation */}
            <div className="col-sm-6 col-lg-2">
              <div className="footer-heading">Navigation</div>
              {navLinks.map(l => (
                <button key={l.id} className="footer-link" onClick={() => go(l.id)}>{l.label}</button>
              ))}
            </div>

            {/* Resources */}
            <div className="col-sm-6 col-lg-2">
              <div className="footer-heading">Resources</div>
              {resourceLinks.map(l => (
                <button key={l.id} className="footer-link" onClick={() => go(l.id)}>{l.label}</button>
              ))}
              <a
                href="https://www.researchgate.net/topic/Plant-Disease-Detection"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Research Papers
              </a>
              <a
                href="https://www.fao.org/plant-health-2020/en/"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                FAO Plant Health
              </a>
            </div>

            {/* Crops + University */}
            <div className="col-lg-4">
              <div className="footer-heading">Supported Crops</div>
              <div className="d-flex flex-wrap gap-2 mb-4">
                <span className="crop-badge crop-tomato">🍅 Tomato</span>
                <span className="crop-badge crop-maize">🌽 Maize</span>
              </div>
              <div className="footer-heading mt-3">Academic Institution</div>
              <div style={{ fontSize: '.88rem', color: 'var(--text-muted)', lineHeight: 1.8 }}>
                The Islamia University of Bahawalpur<br />
                Department of Software Engineering<br />
                Faculty of Computing<br />
                Session: Fall 2022 – Spring 2026
              </div>
            </div>

          </div>
          <hr className="footer-divider" />
          <div className="d-flex flex-wrap justify-content-between align-items-center footer-bottom">
            <div>© 2026 CropGuard AI · Islamia University of Bahawalpur · All Rights Reserved</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <span>Supervised by Ms. Rubab Sheikh</span>
              <button
                onClick={onAdminClick}
                style={{ background: 'none', border: '1px solid rgba(82,183,136,.2)', borderRadius: 7, color: 'var(--text-muted)', padding: '4px 12px', cursor: 'pointer', fontSize: '.75rem', fontFamily: 'DM Sans,sans-serif' }}
              >
                <i className="bi bi-shield-lock"></i> Admin
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Back to top */}
      <button className={`back-to-top ${showTop ? 'show' : ''}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Back to top">
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
}
